import {Image} from '@/_application/core/components/ui/image';
import Link from '@/_application/core/components/ui/link';
import {productPlaceholder} from '@/lib/placeholders';
import {HomepageFeaturedBlock} from '__generated__/__types__';
import cn from 'classnames';

enum HomeFeaturedBlogBannerLayoutType {
    TWO_IMAGES_FIRST_LARGER = '1',
    TWO_IMAGES_SECOND_LARGER = '2',
    TWO_IMAGES_EQUAL_SIZE = '3',
    ONE_IMAGE_FULL_WIDTH = '4',
}

const ProductCategorySpotlightBanner = ({data}: {data: HomepageFeaturedBlock}) => {
    if (!data?.layout) return null;

    const layoutBanner = data?.layout as HomeFeaturedBlogBannerLayoutType;
    const imageShowQuantity = layoutBanner === HomeFeaturedBlogBannerLayoutType.ONE_IMAGE_FULL_WIDTH ? 1 : 2;

    const getProductCategorySpotlightBannerClass = (index: number): string => {
        switch (layoutBanner) {
            case HomeFeaturedBlogBannerLayoutType.TWO_IMAGES_FIRST_LARGER:
                return index === 0 ? 'w-3/5' : 'w-2/5';
            case HomeFeaturedBlogBannerLayoutType.TWO_IMAGES_SECOND_LARGER:
                return index === 1 ? 'w-3/5' : 'w-2/5';
            case HomeFeaturedBlogBannerLayoutType.TWO_IMAGES_EQUAL_SIZE:
                return 'w-1/2';
            default:
                return 'w-full';
        }
    };

    return (
        <div className="flex gap-5">
            {data?.featured_images?.slice(0, imageShowQuantity).map((item, index) => (
                <div
                    key={`${item?.link}-${index}`}
                    className={cn('h-full', getProductCategorySpotlightBannerClass(index))}>
                    <Link href={item?.link ?? 'javascript:;'}>
                        <Image
                            src={item?.url ?? productPlaceholder}
                            alt="Banner"
                            width={500}
                            height={230}
                            className="h-[230px] w-full rounded-[0.625rem] object-cover"
                        />
                    </Link>
                </div>
            ))}
        </div>
    );
};

export default ProductCategorySpotlightBanner;
